module.exports = __webpack_public_path__ + "static/media/footerIcon.1e4b6b9a.svg";